import { Check } from "lucide-react";
import { NotifyForm } from "@/components/NotifyForm";

const Row = ({ children }) => (
  <li className="flex items-start gap-3 text-sm leading-relaxed">
    <Check className="w-4 h-4 text-[#C9A227] mt-0.5 shrink-0" strokeWidth={3} />
    <span>{children}</span>
  </li>
);

export const Audience = () => (
  <section id="pricing" data-testid="pricing-section" className="bg-white py-24 px-6 md:px-12">
    <div className="max-w-7xl mx-auto">
      <p className="text-[#8A6A00] text-xs font-semibold tracking-widest uppercase">Built for both sides of the lease</p>
      <h2 className="mt-3 font-heading font-extrabold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#14213D]">
        For tenants. For landlords.
      </h2>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl">
        <div
          data-testid="tenant-card"
          className="bg-[#F7F6F2] border border-[#2C3B5E]/20 rounded-xl p-10 transition-all duration-300 hover:border-[#C9A227]/50"
        >
          <p className="text-xs font-semibold tracking-widest uppercase text-[#5B6474]">For tenants</p>
          <h3 className="mt-3 font-heading font-extrabold text-xl sm:text-2xl text-[#14213D] tracking-tight">
            Document once. Dispute never — or win if you must.
          </h3>
          <ul className="mt-8 space-y-4 text-[#5B6474]">
            <Row>Free unlimited capture — every photo fingerprinted and timestamped</Row>
            <Row>Guided room-by-room walkthrough so nothing gets missed</Row>
            <Row>On-device blur protects faces and documents before upload</Row>
            <Row>Certified, court-presentable PDF when you need it</Row>
          </ul>
          <div className="mt-10 flex items-baseline gap-2">
            <span data-testid="tenant-price" className="font-heading font-extrabold text-4xl text-[#14213D]">$11.99</span>
            <span className="text-sm text-[#5B6474]">per certified report · capture is free</span>
          </div>
        </div>

        <div
          data-testid="landlord-card"
          className="bg-[#14213D] rounded-xl p-10 relative overflow-hidden transition-all duration-300 hover:shadow-xl"
        >
          <p className="text-xs font-semibold tracking-widest uppercase text-[#C9A227]">For landlords</p>
          <h3 className="mt-3 font-heading font-extrabold text-xl sm:text-2xl text-[#F7F6F2] tracking-tight">
            AB 2801-ready documentation, built in.
          </h3>
          <ul className="mt-8 space-y-4 text-[#F7F6F2]/75">
            <Row>AB 2801-ready photo documentation at move-in and move-out</Row>
            <Row>Deduction statements with required photos built in</Row>
            <Row>21-day deposit return-deadline tracker with notifications</Row>
            <Row>Countersign requests to tenants — no app needed on their side</Row>
          </ul>
          <div className="mt-10 flex items-baseline gap-2">
            <span data-testid="landlord-price" className="font-heading font-extrabold text-4xl text-[#F7F6F2]">$19.99</span>
            <span className="text-sm text-[#F7F6F2]/60">/ year · Landlord Pro</span>
          </div>
          <p className="mt-6 text-xs text-[#F7F6F2]/50 leading-relaxed">
            Designed to support California AB 2801 photo requirements. Guidance for more states and countries coming soon.
          </p>
          <NotifyForm />
        </div>
      </div>
    </div>
  </section>
);
